// Shared button styling for celebration shade actions (Next / Close /
// "Add to..." etc.). Keep variant/color on the <Button> so theme colors
// stay the source of truth — this constant only carries typography and
// shape.
export const celebrationButtonSx = {
  fontFamily: "'Proxima Nova', sans-serif",
  fontWeight: 700,
  fontSize: 15,
  lineHeight: "26px",
  borderRadius: "8px",
  height: 48,
  px: 2,
  textTransform: "none",
} as const;
